{
  "slug": "iq-test-validity",
  "title": "IQ Test Validity Explained",
  "description": "Understand what makes an IQ-test interpretation valid and why validity depends on purpose, population, conditions, and evidence.",
  "summary": "Validity is not a permanent stamp attached to a test. It is the strength of evidence supporting a particular interpretation and use of scores.",
  "category": "Science of testing",
  "sections": [
    {
      "heading": "Validity belongs to an interpretation",
      "paragraphs": [
        "Evidence may support using scores to describe selected cognitive performance in one population without supporting diagnosis, hiring, school placement, or admission in another context.",
        "The question is not simply “Is this test valid?” but “Is this interpretation justified for these people, conditions, and consequences?”"
      ]
    },
    {
      "heading": "Types of supporting evidence",
      "paragraphs": [
        "Developers examine task content, internal structure, relationships with other variables, response processes, fairness, reliability, and consequences. No single correlation or expert opinion settles every use.",
        "Norms must be relevant, instructions standardized, and scoring transparent enough for the intended claim."
      ]
    },
    {
      "heading": "Warning signs online",
      "paragraphs": [
        "Be cautious when a site promises an exact IQ from a very short quiz, hides its norms, confuses entertainment with diagnosis, or claims universal cultural neutrality.",
        "A responsible online assessment describes itself as indicative when it cannot support professional or high-stakes interpretations."
      ]
    }
  ],
  "faqs": [
    {
      "question": "Can an online IQ test be valid?",
      "answer": "It can support limited interpretations if design, norms, delivery, and evidence fit that use; this does not make it valid for every decision."
    },
    {
      "question": "Does reliability prove validity?",
      "answer": "No. Consistent scores can still support the wrong interpretation or measure the wrong thing."
    }
  ],
  "related": [
    "iq-test-reliability",
    "is-an-online-iq-test-accurate",
    "supervised-vs-unsupervised-iq-tests",
    "iq-test-accommodations-and-accessibility"
  ],
  "sources": [
    {
      "label": "Standards for Educational and Psychological Testing",
      "url": "https://www.testingstandards.net/"
    },
    {
      "label": "International Test Commission — technology-based assessment guidelines",
      "url": "https://www.intestcom.org/page/16"
    }
  ]
}
